import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ButtonNav } from '@zapier/design-system';
import { useState } from 'react';
import { BuilderBlocks } from '@builder.io/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { useTracking } from '../../tracking';
const Styles = labelStyles('ButtonNavSection', {
    root: css({
        maxWidth: '1170px',
        margin: '0 auto',
    }),
    content: css({
        padding: '20px',
        marginTop: '20px',
    }),
    buttonNavContainer: css({
        margin: '20px',
    }),
});
export function ButtonNavSection(props) {
    const [visibleIndex, setVisibleIndex] = useState(0);
    const { emitUserInteractionEvent } = useTracking();
    const buttonNavItems = props.buttons.map((button, index) => {
        return Object.assign(Object.assign({}, button), { index, key: `${index}` });
    });
    const handleOnClick = (button) => {
        setVisibleIndex(button.index);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'button_click',
            interaction_raw_text: button.text,
            option_selected: 'button',
        });
    };
    return (_jsxs("div", Object.assign({ css: Styles.root }, { children: [_jsx("div", Object.assign({ css: Styles.buttonNavContainer }, { children: _jsx(ButtonNav, { ariaLabel: props.ariaLabel, items: buttonNavItems, selectedItemKey: visibleIndex.toString(), onChooseItem: (button) => handleOnClick(button), isButtonFullWidth: props.isButtonFullWidth, align: props.align, perRow: props.perRow, wrap: props.wrap }) })), _jsx("div", Object.assign({ css: Styles.content }, { children: _jsx(BuilderBlocks, { blocks: props.buttons[visibleIndex].content, dataPath: `component.options.buttons.${visibleIndex}.content`, parentElementId: props.builderBlock.id }) }))] })));
}
//# sourceMappingURL=ButtonNavSection.js.map